/**
 * Haal de pagina's via een geprepareerde JSON op (deze actie is eenmalig)
 *
 * Ten behoeve van het wachtscherm (ContentPagePreloader), is er sowieso een delay van 2000 ms
 *
 * @history
 * 19 september 2023
 * background
 *
 * 8 augustus 2023
 * isPageFieldRequired(p_fase, p_page)
 *
 * 27 juli 2023
 * getPageFontSize
 *
 * 2 augustus 2022
 * getProgrammersField(p_fase, p_page)
 *
 * 1 augustus 2022
 * refactor tot aparte klasse die wel de state van window.app aanpast
 *
 * 20 juli 2022
 * Start implementatie
 *
 */
export class Pages
{
    constructor() {
        this.pages = [];
    }




    loadPages()
    {

        const requestOptions = {
            method: 'POST',
        };

        fetch("/get_pages", requestOptions)
            .then(response => response.json())
            .then(pages_json =>
            {
                if (pages_json.status == "ok")
                {
                    this.pages = pages_json.data;
                   window.app.setState({"init_done":true});

                }
                else
                {
                    console.log("?");
                }
            });
    }

    getPageContent(p_fase, p_page)
    {
        return this.pages[p_fase][p_page];
    }

    getPageID(p_fase, p_page)
    {
        return this.pages[p_fase][p_page].id;
    }

    getPageKind(p_fase, p_page)
    {
        return this.pages[p_fase][p_page].kind;
    }


    pageHasTeacherInfo(p_fase, p_page)
    {
        return this.pages[p_fase][p_page].teacher_pages.length > 0;
    }

    getTeacherInfo(p_fase, p_page)
    {
        return this.pages[p_fase][p_page].teacher_pages;
    }

    pageHasBackgroundInfo(p_fase, p_page)
    {
        return this.pages[p_fase][p_page].background_pages.length > 0;
    }

    getBackgroundInfo(p_fase, p_page)
    {
        return this.pages[p_fase][p_page].background_pages;
    }

    getTotPages(p_fase)
    {
        return this.pages[p_fase].length;
    }

    getPageFontSize(p_fase, p_page)
    {
        return this.pages[p_fase][p_page].font_size;
    }

    hasPageField(p_fase, p_page)
    {
        return this.pages[p_fase][p_page].has_field;
    }

    isPageFieldRequired(p_fase, p_page)
    {
       if (this.pages[p_fase][p_page].has_field)
       {
           return this.pages[p_fase][p_page].field.required;
       }
       return false;
    }

    findPageFaseAndPageIndex(p_page_id)
    {
        for (let f=0; f <=7; f++)
        {
            if (typeof this.pages[f] != "undefined")
            {
                for (let p=0; p < this.pages[f].length; p++)
                {
                    if (this.pages[f][p].id == p_page_id)
                    {
                        return {fase: f, page: p};
                    }
                }
            }
        }
        return {fase:-1, page:-1};
    }

}
